export default __webpack_public_path__ + "static/LandingPage-7f7d288ddf0759aea22a140b0a119907.mp4";